import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ngapplication',
	templateUrl:'./NGApplicationPluginCompPage.html',
	styles: [],
	styleUrls:['./NGApplicationPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class NGApplicationPluginCompPage
{
	mdContent_1077 = `\`\`\`java
import com.jwebmp.core.angular.NGApplication;
\`\`\``;
	mdContent_1078 = `\`\`\`java
extends NGApplication
\`\`\``;
}
